export const MUSIC_PLAYBACK = "as_music_playback_time";
export const AVAILABLE_TIME = 360;
